// Lista ticket recenti nella dashboard
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import type { Ticket } from '@fieldcore/types'
import { Card, CardHeader, CardTitle } from '../../../components/ui/Card'
import { StatusPill } from '../../../components/ui/StatusPill'
import { PriorityIndicator } from '../../../components/ui/PriorityIndicator'
import { Skeleton } from '../../../components/ui/Skeleton'
import { formatRelativeDate } from '../../../lib/utils'
import { formatTicketNumber } from '@fieldcore/utils'

interface RecentTicketsProps {
  tickets?: Ticket[]
  isLoading?: boolean
}

export function RecentTickets({ tickets = [], isLoading }: RecentTicketsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Ticket recenti</CardTitle>
        <Link
          to="/tickets"
          className="flex items-center gap-1 text-xs text-[var(--fc-primary)] hover:underline"
        >
          Vedi tutti <ArrowRight className="h-3 w-3" />
        </Link>
      </CardHeader>

      {isLoading ? (
        <div className="space-y-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <Skeleton width={80} height={14} />
              <Skeleton height={14} className="flex-1" />
              <Skeleton width={60} height={20} className="rounded-full" />
            </div>
          ))}
        </div>
      ) : tickets.length === 0 ? (
        <p className="py-6 text-center text-sm text-[var(--fc-foreground-muted)]">
          Nessun ticket recente
        </p>
      ) : (
        <ul className="divide-y divide-[var(--fc-border)]" role="list">
          {tickets.slice(0, 7).map((ticket) => (
            <li key={ticket.id} className="py-3">
              <Link
                to={`/tickets/${ticket.id}`}
                className="flex items-center gap-3 hover:bg-[var(--fc-surface-raised)] -mx-4 px-4 rounded transition-colors"
              >
                <span className="shrink-0 font-mono text-xs text-[var(--fc-foreground-muted)]">
                  {ticket.ticketNumber}
                </span>
                <span className="flex-1 truncate text-sm text-[var(--fc-foreground)]">
                  {ticket.title}
                </span>
                <div className="flex shrink-0 items-center gap-2">
                  <PriorityIndicator priority={ticket.priority} showLabel={false} />
                  <StatusPill status={ticket.status} size="sm" />
                  <span className="hidden text-xs text-[var(--fc-foreground-subtle)] sm:block">
                    {formatRelativeDate(ticket.createdAt)}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Card>
  )
}
